import React from 'react';
import styled from 'styled-components';

const Card = styled.article`
  border-radius: 24px;
  padding: 24px;
  background: rgba(20, 22, 35, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.45);
`;

const Top = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

const Logo = styled.img`
  width: 56px;
  height: 56px;
  border-radius: 18px;
  object-fit: cover;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Role = styled.h3`
  margin: 0;
  font-size: 18px;
  color: ${({ theme }) => theme.text_primary};
`;

const Company = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.text_secondary};
`;

const Date = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.text_secondary};
  font-size: 14px;
`;

const Description = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.text_secondary};
  line-height: 1.6;
`;

const SkillList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const Skill = styled.span`
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 13px;
  background: rgba(133, 76, 230, 0.12);
  color: ${({ theme }) => theme.text_primary};
`;

const ExperienceCard = ({ experience }) => (
  <Card>
    <Top>
      <Logo src={experience.img} alt={experience.company} />
      <Body>
        <Role>{experience.role}</Role>
        <Company>{experience.company}</Company>
        <Date>{experience.date}</Date>
      </Body>
    </Top>
    {experience?.desc && <Description>{experience.desc}</Description>}
    {experience?.skills && (
      <SkillList>
        {experience.skills.map((skill) => (
          <Skill key={skill}>{skill}</Skill>
        ))}
      </SkillList>
    )}
  </Card>
);

export default ExperienceCard;